import { useQuery, keepPreviousData } from "@tanstack/react-query";

import {
  getAuditLog,
  getGroupedAuditLog,
  type GetAuditLogParams,
} from "../../services/auditLog";

export type { GetAuditLogParams };

export function useAuditLog(params: GetAuditLogParams = {}) {
  return useQuery({
    queryKey: ["audit-log", params],
    queryFn: () => getAuditLog(params),
    placeholderData: keepPreviousData,
  });
}

export function useGroupedAuditLog(params: GetAuditLogParams = {}) {
  return useQuery({
    queryKey: ["audit-log-grouped", params],
    queryFn: () => getGroupedAuditLog(params),
    placeholderData: keepPreviousData,
  });
}
